import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-choferes-tabla',
  templateUrl: './choferes-tabla.component.html',
  styleUrls: ['./choferes-tabla.component.scss']
})
export class ChoferesTablaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
